import React, { useEffect } from 'react';
import AppHeader from 'v2/components/AppHeader';
import ProjectListContent from './ProjectListContent';
import ProjectListBottomBar from './components/ProjectListBottomBar';
import './ProjectList.scss';
import WelcomeNewOrganization from './components/welcome/WelcomeNewOrganization';
import { useWelcome } from '../../../hooks/wellcome';
import { useDispatch } from 'react-redux';
import {
  hideOrganizationInfo,
  showOrganizationInfo,
} from 'v2/store/ui/actions/headerActions';

const ProjectList: React.FC = () => {
  const dispatch = useDispatch();
  const { isWelcomeVisible, onClose } = useWelcome();

  useEffect(() => {
    dispatch(showOrganizationInfo());

    return () => {
      dispatch(hideOrganizationInfo());
    };
  }, []);

  return (
    <div className="project-list-app-layout-v2">
      {isWelcomeVisible && <WelcomeNewOrganization onClose={onClose} />}
      <div style={{ width: '100%' }}>
        <AppHeader isMarginLeft={isWelcomeVisible} />
        <div className="app-header-placeholder-v2" />
        <ProjectListContent />
        <div className="project-list-bottom-bar-placeholder" />
        <ProjectListBottomBar />
      </div>
    </div>
  );
};

export default ProjectList;
